export default "__VITE_ASSET__CSLqC1qb__"